export default "__VITE_ASSET__afa509d0__"